@charset "UTF-8";
:root {
  /* 'EmojiMart' represents the general emoji font of the app, themes may redefine it */
  --emojifonts: "EmojiMart", "Apple Color Emoji", NotoEmoji;
  --fonts-default:
    Roboto, var(--emojifonts), "Helvetica Neue", Arial, Helvetica, NotoMono,
    sans-serif;
  --fonts-system: system-ui, var(--fonts-default);
}

/* Theming Colors */
.dialog {
  padding: 0;
}
.dialog.unstyled {
  background: none;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  border: none;
  margin: 0;
}
.dialog:not(.unstyled) {
  background-color: var(--bp4DialogBgPrimary);
  color: var(--globalText);
  border-radius: 10px;
  border: none;
  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 4px 8px rgba(16, 22, 26, 0.2), 0 0 20px 3px rgba(16, 22, 26, 0.2);
  flex-direction: column;
  max-height: calc(100% - 50px);
  max-width: min(733px, 100vw - 1rem);
  min-width: min(350px, 100vw - 1rem);
  width: unset;
  justify-content: center;
  padding: 0;
}
.dialog:not(.unstyled):not(.noTopPadding) {
  /* we always add 20px top padding if not explicitly disabled */
  padding-top: 20px;
}
.dialog::backdrop {
  background-color: var(--dialogBackdropBackground);
}

/* Big dialogs (settings, about, gallery, profiles, new chat, QR scanner…)
   go edge-to-edge on small/mobile viewports: full screen, no rounded
   corners, no margin or drop shadow. Opt in with the `fullscreenOnMobile`
   prop on <Dialog> / <DialogWithHeader>. */
@media (max-width: 500px) {
  .dialog:not(.unstyled).fullscreenOnMobile {
    border-radius: 0;
    box-shadow: none;
    margin: 0;
    width: 100vw;
    min-width: 100vw;
    max-width: 100vw;
    height: 100dvh;
    max-height: 100dvh;
  }
  .dialog:not(.unstyled).fullscreenOnMobile:not(.noTopPadding) {
    /* keep some breathing room above the header, and clear the device
       status bar / notch on mobile */
    padding-top: calc(20px + env(safe-area-inset-top, 0px));
  }
  .dialog:not(.unstyled).fullscreenOnMobile .dialogBody {
    max-height: none;
  }
}
.dialogHeader {
  width: 100%;
  align-items: center;
  background-color: var(--bp4DialogHeaderBg);
  border-bottom: var(--outlineProperties);
  display: flex;
  padding-bottom: 20px;
  padding-inline-start: 30px;
  padding-inline-end: 25px;
  user-select: none;
}

.dialogHeading {
  align-items: center;
  color: var(--bp4Heading);
  display: flex;
  flex: 1 1 auto;
  font-size: 18px;
  font-weight: 600;
  height: 30px;
  margin: 0;
}

.dialogBody {
  width: 100%;
  background-color: var(--bp4DialogBgPrimary);
  flex: 1 1 auto;
  max-height: 90vh;
  overflow: overlay;
}
.dialogBody::-webkit-scrollbar-track {
  background: transparent;
}

.dialogContent {
  padding-inline-start: 30px;
  padding-inline-end: 30px;
  line-height: 22px;
  /* override additional top margins of the first element
     in dialog content, the whole dialog already has 20px
   */
}
.dialogContent:not(.allowTopPadding) > :first-child {
  margin-top: 0 !important;
}

.dialogFooter {
  width: 100%;
  background-color: var(--bp4DialogBgPrimary);
  padding-bottom: 20px;
  padding-inline-start: 30px;
  padding-inline-end: 30px;
}

.headerButton {
  align-items: center;
  background-color: transparent;
  border-radius: 5px;
  border: 0;
  cursor: pointer;
  display: flex;
  height: 30px;
  justify-content: center;
  padding: 0;
  width: 30px;
}
.headerButton + .headerButton {
  margin-inline-start: 5px;
}
.headerButton:hover {
  background-color: var(--chatListItemBgHover);
}

.headerButtonIcon {
  background-color: var(--iconColorPrimary);
  margin: 0 !important;
}

.headerThreeDotButton {
  margin: 0 !important;
  padding: 0 !important;
  transform: rotate(90deg);
}

.backButton {
  margin-inline-end: 20px;
}
:global([dir="rtl"]) .backButton {
  transform: rotate(180deg);
}

.footerActions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.footerActions.spaceBetween {
  justify-content: space-between;
}
.footerActions.start {
  justify-content: flex-start;
}
.footerActions.end {
  justify-content: flex-end;
}
.footerActions.center {
  justify-content: center;
}

.footerActionButton {
  min-width: 100px;
  flex: 0 1 auto;
  margin: 0;
}